/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_CreateInputs */

const en_user_create = /** @type {(inputs: User_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const ja_user_create = /** @type {(inputs: User_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

const fr_user_create = /** @type {(inputs: User_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer`)
};

const de_user_create = /** @type {(inputs: User_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {User_CreateInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_create = /** @type {((inputs?: User_CreateInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_CreateInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_create(inputs)
	if (locale === "ja") return ja_user_create(inputs)
	if (locale === "fr") return fr_user_create(inputs)
	return de_user_create(inputs)
});